import { Router } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";
import { MetaProvider, Title } from "@solidjs/meta";
import { Suspense, ErrorBoundary } from "solid-js";
import { Footer } from "~/components";
import { UserProvider } from "~/context/UserProvider";

import "./app.css";

export default function App() {
  return (
    <Router
      root={props => (
        <UserProvider>
          <MetaProvider>
            <Title>RIAS Regs</Title>

            <Suspense>{props.children}</Suspense>

            <Footer />
          </ MetaProvider>
        </UserProvider>
      )}
    >
      <FileRoutes />
    </Router>
  );
}
